export type RunningHubFeatureType =
  | 'upscale'
  | 'tone_mapping'
  | 'light_reconstruct'
  | 'text_reconstruct'
  | 'physical_reconstruct';

export type RunningHubActiveJobSummary = {
  id: string;
  feature_type: RunningHubFeatureType;
  history_client_item_id: string;
  status: 'processing' | 'completed' | 'failed' | 'expired';
  runninghub_task_id?: string;
  thumb_url?: string;
  result_urls?: Record<string, unknown>;
  created_at?: string;
  updated_at?: string;
  completed_at?: string;
  history_archived_at?: string;
};

export type RunningHubActiveListWarning = {
  code: string;
  job_id?: string;
  feature_type?: RunningHubFeatureType;
};

export type RunningHubActiveJobsResponse = {
  processing: RunningHubActiveJobSummary[];
  completed_unacked: RunningHubActiveJobSummary[];
  /** Phase-1: 单用户列表降级（如坏行跳过），不影响其它用户 */
  warnings?: RunningHubActiveListWarning[];
  /** Phase-1: true 表示本次 /active 为安全降级响应（仍 200） */
  degraded?: boolean;
};

export type RunningHubJobDetailResponse = {
  job: RunningHubActiveJobSummary;
  history_payload: Record<string, unknown> | null;
};

export const RUNNING_HUB_FEATURE_LABELS: Record<RunningHubFeatureType, { zh: string; en: string }> = {
  upscale: { zh: '高清放大', en: 'Upscale' },
  tone_mapping: { zh: '色调映射', en: 'Tone mapping' },
  light_reconstruct: { zh: '光影重构', en: 'Light reconstruct' },
  text_reconstruct: { zh: '文本重构', en: 'Text reconstruct' },
  physical_reconstruct: { zh: '物理重构', en: 'Physical reconstruct' },
};
